import React, { useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";

const EditCouponModal = ({
  show,
  handleClose,
  selectedRow,
  formData,
  getCouponList,
  setFilterExpiryStatus,
  setShowEditModal,
  handleInputChange,
}) => {
  const [validated, setValidated] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!formData.expireInDays.trim()) {
      setValidated(true);
    } else {
      setValidated(false);
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", selectedRow?.id);
    bodyFormData.append("expire_in_months", formData.expireInDays);
    utils
      .callAPI(
        "post",
        `/Coupon/edit`,
        bodyFormData
      )
      .then((res) => {
        setValidated(false);
        getCouponList();
        setShowEditModal(false)
        setFilterExpiryStatus('all')
      })
      .catch((err) => {});
  };

  return (
    <RB.Modal show={show} onHide={handleClose}>
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>Change Coupon Expire</RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        {selectedRow && (
          <RB.Form noValidate validated={validated} onSubmit={onSubmit}>
            <div className="mb-3">
              Coupon Code:<strong> {selectedRow.coupon_code}</strong>
            </div>

            <div className="mb-3">
              <RB.FloatingLabel className="floating-label-fancy">
                <RB.InputGroup hasValidation>
                  <RB.Form.Control
                    type="text"
                    name="expireInDays"
                    placeholder="Expire in"
                    value={formData.expireInDays}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                    required
                  />
                  <RB.InputGroup.Text className="border-end-0 border-top-0">
                    Month
                  </RB.InputGroup.Text>
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter expiry in months.
                  </RB.Form.Control.Feedback>
                </RB.InputGroup>
              </RB.FloatingLabel>
            </div>

            <RB.Modal.Footer>
              <RB.Button variant="secondary" onClick={handleClose}>
                Close
              </RB.Button>
              <RB.Button variant="primary" type="submit">
                Save Changes
              </RB.Button>
            </RB.Modal.Footer>
          </RB.Form>
        )}
      </RB.Modal.Body>
    </RB.Modal>
  );
};

export default EditCouponModal;
